import { report } from 'lib/utils/dataReport';
import { ATTA_REPORT } from 'lib/constants/atta';
import { SMS_MODAL_STYLE } from 'lib/constants/operator';

/**
 * 翼支付（dxyzf 样式3）协议合规埋点公共参数
 * 需求 EVT-20~EVT-29 的"关键参数"列均要求 packageId + captchaModalType=`dxyzf`
 * （部分还需 agreementVersion），统一在此处拼装，避免业务调用点遗漏。
 */
export const CAPTCHA_MODAL_TYPE_DXYZF = SMS_MODAL_STYLE.STYLE_3;

export interface AgreementReportContext {
  packageId?: string;
  agreementVersion?: string;
}

export type AgreementFallbackErrorType = 'configMissing' | 'parseFail' | 'versionMissing' | 'modalTypeMismatch';

/**
 * 拼装协议合规埋点的 extraStatisticParams：
 * - 始终带 captchaModalType=`dxyzf`
 * - packageId / agreementVersion 存在则带（缺失时不写空字符串，便于数据侧识别真正缺失）
 */
export function buildAgreementReportParams(
  context: AgreementReportContext,
  extra?: Record<string, unknown>,
): Record<string, unknown> {
  const params: Record<string, unknown> = {
    captchaModalType: CAPTCHA_MODAL_TYPE_DXYZF,
    ...(context.packageId ? { packageId: context.packageId } : {}),
    ...(context.agreementVersion ? { agreementVersion: context.agreementVersion } : {}),
    ...(extra || {}),
  };
  return params;
}

/** 上报协议配置降级埋点（EVT-24） */
export function reportAgreementFallback(
  errorType: AgreementFallbackErrorType,
  context: AgreementReportContext & { captchaModalType?: string },
): void {
  // EVT-24 的 captchaModalType 允许是真实弹窗类型（如 `dx`/`cmcc`），用于排查 modalTypeMismatch
  const params: Record<string, unknown> = {
    captchaModalType: context.captchaModalType ?? CAPTCHA_MODAL_TYPE_DXYZF,
    errorType,
    ...(context.packageId ? { packageId: context.packageId } : {}),
    ...(context.agreementVersion ? { agreementVersion: context.agreementVersion } : {}),
  };
  report(ATTA_REPORT.VERIFY.AGREEMENT_CONFIG_FALLBACK, { extraStatisticParams: params });
}
